<template>
  <div
    id="register"
    :style="'height:' + clientHeight + 'px;padding-bottom:15px;'"
    class="content self_c"
  >
    <headNav
      :rightText="window_c['Login']"
      :back="true"
      title=" "
      @rightClick="toLogin"
      :flag="true"
    />
    <div class="self_b">
      <div class="cell-content self-content">
        <p
          class="cell-title self_cell-title"
          slot="title"
        >
          {{ window_c["Welcome to join Us"] }}
        </p>
        <p
          class="cell-desc self_cell-desc"
          slot="title"
        >
          {{ window_c["Join the membershio to get offer"] }}
        </p>
        <div class="cell-form self_cell-form">
          <div class="self_cell-group_title self_cell-group_title_1">
            {{ window_c["Mobile number"] }}
          </div>

          <div class="areaCode">
            <area-code @change="selectCountry" />
            <van-field
              class="self_cell-input"
              v-model="form.phone"
              @input="phoneReg"
              type="number"
              :maxlength="phoneMaxLength"
              center
              clearable
              :placeholder="window_c['Enter your mobile number']"
            >
              <button
                class="cell-code"
                slot="button"
                :disabled="disabled"
                @click="getCode"
              >
                {{ code_text }}
              </button>
            </van-field>
          </div>
          <div class="self_cell-group_title">
            {{ window_c["Verification code"] }}
          </div>
          <van-field
            class="self_cell-input"
            type="number"
            maxlength="6"
            @input="yzmReg"
            v-model="form.authCode"
            center
            clearable
            :placeholder="window_c['Enter the verification code']"
          />
          <div class="self_cell-group_title">{{ window_c["Password"] }}</div>
          <van-field
            class="self_cell-input"
            v-model="form.password"
            maxlength="20"
            clearable
            :type="!isshow ? 'password' : 'text'"
            :placeholder="window_c['Enter your password within 6-20 words']"
          >
            <img
              class="cell-icon"
              v-if="!isshow"
              @click="viewPassword"
              src="../assets/biyan.png"
              slot="right-icon"
              alt
            />
            <img
              class="cell-icon"
              v-else
              @click="viewPassword"
              src="../assets/zhengyan.png"
              slot="right-icon"
              alt
            />
          </van-field>
          <div v-if="showRecommendation">
            <div
              class="self_cell-group_title"
              v-text="window_c['Recommendation code']"
            ></div>
            <van-field
              class="self_cell-input"
              v-model="form.recommendationCode"
              @blur="codeBlur"
              center
              maxlength="6"
              clearable
              :readonly="recommendationReadonly"
              :placeholder="window_c['Please enter the recommendation code']"
            />
          </div>
          <van-checkbox
            slot="title"
            @change="changeRead"
            v-model="form.checked"
            :checked-color="color_"
          >
            <p
              class="cell-clause self_cell-clause "
              @click="isRead"
            >
              {{ window_c["Please read and agree terms and conditions "] }}
              <span class="conditions self_color">{{
                window_c["terms and conditions "].trim()
              }}</span>
              {{ window_c["to become member of The Food Story"] }}
            </p>
          </van-checkbox>
        </div>
      </div>
      <div
        class="cell-button"
        style="margin-top:auto;"
      >
        <p
          @click="register"
          :style="
            !form.phone ||
            (form.phone &&
              (form.phone.length != 8 && form.phone.length != 11)) ||
            !form.authCode ||
            (form.authCode && form.authCode.length != 6) ||
            !form.password ||
            (form.password && form.password.length < 6) ||
            !form.checked ||
            !smsCodeFlag
              ? 'background-color:#ccc;'
              : 'background-color:' + color_
          "
        >
          <!-- 註冊 -->
          {{ window_c["Login"] }}
        </p>
      </div>
      <!-- 條款 -->
      <van-popup
        class="cell-Dialog-box"
        v-model="showDialog"
      >
        <div class="cell-Dialog-content">
          <div
            class="cell-container"
            :style="'height:' + (window_.tk_g - 130) + 'px;'"
          >
            <div
              v-for="(item, index) in content"
              :key="index"
              class="cell-container-item"
            >
              <p
                v-text="item.resourceName"
                class="cell-container-title"
              ></p>
              <div v-html="item.content"></div>
            </div>
          </div>
          <div class="cell-agree">
            <van-checkbox
              slot="title"
              @change="changeRead"
              v-model="form.checked"
              :checked-color="color_"
            >
              <p
                class="cell-clause"
                @click="isRead"
              >
                {{ window_c['Please read and agree terms and conditions '] }}
                <span class="conditions self_color">{{ window_c['terms and conditions '].trim() }}</span>
                {{ window_c['to become member of The Food Story'] }}
              </p>
            </van-checkbox>
          </div>
          <div class="cell-button cell-button-box self_bg_color">
            <p
              @click="showDialog = false"
              class="self_bg_color"
            >
              {{ form.checked ? window_c['confirm'] : window_c['Back'] }}
            </p>
          </div>
        </div>
      </van-popup>
      <!-- <iframe :src="thUrl" style="display: none;"></iframe> -->
    </div>
  </div>
</template>
<script>
import myfn from "@/js/util";
import areaCode from "@/components/areaCode.vue";
import {
  sendSms,
  getResourceInfo,
  registerOth,
  joinBrand,
  getBandName,
  checkInvitationCode,
  checkSmsCode
} from "@/js/api";
import headNav from "@/components/headNav";
import desUtil from "@/js/DesUtil";
import lang_ from "@/js/locales";
export default {
  data () {
    return {
      window_c: {
        Login: "登入",
        "Mobile number": "手機號碼",
        "Enter your mobile number": "輸入手機號碼",
        Password: "密碼",
        "Enter your password within 6-20 words": "輸入6-20個字符",
        "Welcome to join Us": "成為會員",
        "Join the membershio to get offer": "成為會員儲分享優惠",
        "Verification code": "驗證碼",
        "Enter the verification code": "請輸入驗證碼",
        "Please read and agree terms and conditions ":
          "已閱讀並同意Foodstory服務",
        "terms and conditions ": "使用協議",
        "to become member of The Food Story": "",
        Back: "返回",
        confirm: "確認",
        "Please enter your mobile number": "請輸入手機號",
        "Mobile number format error": "手機號碼格式錯誤",
        "Please enter the password": "請輸入密碼",
        "Please enter a password of at least 6 digits":
          "請輸入至少6位数以上密碼",
        "Please check the service agreement": "請勾選服務使用協議",
        "Registration success": "註冊成功",
        "Recommendation code": "邀請碼",
        "Please enter the recommendation code": "請輸入邀請碼"
      },
      clientHeight: 603,
      form: {
        checked: false,
        phone: "",
        authCode: "",
        password: "",
        recommendationCode: ""
      },
      recommendationReadonly: false, // 推薦碼是否可編輯
      showRecommendation: false, //是否顯示推薦碼
      recommendationFlag: false, // 推薦碼是否正確, 表示能不能提交
      code_text: "獲取驗證碼",
      disabled: false,
      smsCodeFlag: false, // 是否發送了驗證碼
      smsCodeClick: false, // 是否點擊了驗證按
      times: 60, // 重新獲取所需時間
      countDownTime: 0,
      brandName_: "",
      content: [], // 條款內容
      isshow: false,
      showDialog: false,
      sms: "-2",
      window_: {
        tk_g: 0
      },
      thUrl: "",
      color_: "",
      loginData: {
        countryId: 1
      },
      phoneMaxLength: "8"
    };
  },
  created () {
    myfn.selfSetIcon(); // 設置logo
    myfn.getBrand(this, () => {
      this.color_ = this.themeColor;
    });

    this.getBandName_();
    this.getAgreement();
    this.init_lang();
    // let myTime = sessionStorage.myTime;
    // if (myTime) {
    // 	this.codeCountDown(myTime);
    // }
    sessionStorage.removeItem("myTime");
    let codeT = setInterval(() => {
      let code = localStorage.getItem("invitation_code");
      if (code == 0 || code == 1) {
        this.showRecommendation = code == 0 ? false : true;
        clearInterval(codeT);
      }
    }, 30);
    // 推薦碼
    let recommendationCode = localStorage.getItem("recommendationCode");
    if (recommendationCode) {
      this.form.recommendationCode = recommendationCode;
      this.recommendationReadonly = true;
      this.recommendationFlag = true;
    }
    var userinfo = myfn.userInfo.get(this, 1);//localStorage.userinfo;
    if (!myfn.ISNULL(userinfo)) {
      this.$router.replace({
        name: "vipCard",
        params: {
          arg: myfn.setQueryParams(myfn.getBrandId(this, 1))
        }
      });
    }
    this.window_.tk_g = myfn.getWindowInner().h - 40;
  },
  mounted () {
    this.clientHeight = myfn.getWindowInner().h || 603;
  },
  methods: {
    verifyCid (phone, cId) {
      // 判断当前cID跟号码长度是否匹配
      if (
        ((cId == 1 || cId == 2 || cId == 4) && phone.length == 8) ||
        (cId == 3 && phone.length == 11)
      ) {
        return 0; // 成功
      } else {
        return 1; // 失败
      }
    },
    init_lang () {
      var window_c = this.window_c;
      window_c["Login"] = lang_.t("Login");
      window_c["Welcome to join Us"] = lang_.t("Welcome to join Us");
      window_c["Join the membershio to get offer"] = lang_.t(
        "Join the membershio to get offer"
      );
      window_c["Mobile number"] = lang_.t("Mobile number");
      window_c["Enter your mobile number"] = lang_.t(
        "Enter your mobile number"
      );
      window_c["Password"] = lang_.t("Password");
      window_c["Enter your password within 6-20 words"] = lang_.t(
        "Enter your password within 6-20 words"
      );
      window_c["Forget password"] = lang_.t("Forget password");
      window_c["Create Account"] = lang_.t("Create Account");
      window_c["Verification code"] = lang_.t("Verification code");
      window_c["Enter the verification code"] = lang_.t(
        "Enter the verification code"
      );
      window_c["Please read and agree terms and conditions "] = lang_.t(
        "Please read and agree terms and conditions "
      );
      window_c["terms and conditions "] = lang_.t("terms and conditions ");
      window_c["to become member of The Food Story"] = lang_.t(
        "to become member of The Food Story"
      );
      window_c["Back"] = lang_.t("Back");
      window_c["confirm"] = lang_.t("confirm");
      window_c["Please enter your mobile number"] = lang_.t(
        "Please enter your mobile number"
      );
      window_c["Mobile number format error"] = lang_.t(
        "Mobile number format error"
      );
      window_c["Please enter the password"] = lang_.t(
        "Please enter the password"
      );
      window_c["Please enter a password of at least 6 digits"] = lang_.t(
        "Please enter a password of at least 6 digits"
      );
      window_c["Please check the service agreement"] = lang_.t(
        "Please check the service agreement"
      );
      window_c["Registration success"] = lang_.t("Registration success");
      this.code_text = lang_.t("verification code");
      window_c["Recommendation code"] = lang_.t("Recommendation code");
      window_c["Please enter the recommendation code"] = lang_.t(
        "Please enter the recommendation code"
      );
    },
    toLogin () {
      this.$router.push({
        name: "login",
        params: {
          arg: myfn.setQueryParams(myfn.getBrandId(this, 1))
        }
      });
    },
    // 獲取驗證碼
    getCode () {
      if (this.form.phone.length == 11 && this.loginData.countryId != 3) {
        this.$toast(this.window_c["Mobile number format error"]);
        return
      } else if (this.loginData.countryId != 3 && this.form.phone.length != 8) {
        this.$toast(this.window_c["Mobile number format error"]);
        return
      }
      var self = this;
      let a = this.verifyCid(this.form.phone, this.loginData.countryId);
      if (a != 0) {
        this.$toast(this.window_c["Mobile number format error"]);
        return;
      }
      if (this.smsCodeClick) {
        return;
      }
      if (!this.form.phone) {
        this.$toast(self.window_c["Please enter your mobile number"]);
      } else if (!regExpPhone.test(this.form.phone)) {
        this.$toast(self.window_c["Mobile number format error"]);
      } else {
        this.smsCodeClick = true;
        self.$toast.loading({
          message: lang_.t("Loading"),
          forbidClick: true,
          duration: 0,
          loadingType: "spinner"
        });
        var data = {
          phone: this.form.phone,
          smsType: 1,
          type: 1,
          languageId: 4,
          countryId: this.loginData.countryId
        };
        sendSms(data)
          .then(res => {
            self.$toast.clear();
            self.smsCodeClick = false;
            if (res.code == "1" || location.origin.indexOf("m.ricepon") == -1) {
              self.smsCodeFlag = true;
              this.$toast(lang_.t("SMS sending"));
              var times = this.times;
              let endMsRes = new Date().getTime() + parseInt(times * 1000);
              sessionStorage.myTime = JSON.stringify(endMsRes);
              this.codeCountDown(endMsRes, times);
              this.form.sms = res.sms;
            } else {
              this.$toast(res.errorMsg);
            }
          })
          .catch(err => {
            self.$toast.clear();
            self.$toast({
              message: lang_.t("Network instability, please try again")
            });
          });
      }
    },

    // 倒计时
    codeCountDown (endMsRes, times) {
      this.countDownTime = Math.ceil((endMsRes - new Date().getTime()) / 1000);
      if (parseInt(this.countDownTime) < 1) {
        return;
      }
      this.disabled = true;
      this.code_text = this.countDownTime + "s";
      let time = setTimeout(() => {
        this.countDownTime--;
        if (this.countDownTime < 1) {
          this.disabled = false;
          this.countDownTime = times;
          this.code_text = lang_.t("Regain validation code");
          clearTimeout(time);
        } else {
          this.codeCountDown(endMsRes);
        }
      }, 1000);
    },

    // 獲取註冊協議
    getAgreement () {
      var self = this;
      getResourceInfo({
        type: 2,
        brandId: myfn.getBrandId(self, 1)
      }).then(res => {
        this.content = res.data;
      });
    },

    getBandName_ () {
      var self = this;
      getBandName({
        bandId: myfn.getBrandId(self, 1)
      }).then(
        res => {
          var brandName_ = res.data.brandName;
          if (res.data.brandName) {
            self.window_c[
              "Please read and agree terms and conditions "
            ] = self.window_c[
              "Please read and agree terms and conditions "
            ].replace("BRANDNAME", brandName_);
            self.window_c["terms and conditions "] = self.window_c[
              "terms and conditions "
            ].replace("BRANDNAME", brandName_);
            self.window_c["to become member of The Food Story"] = self.window_c[
              "to become member of The Food Story"
            ].replace("BRANDNAME", brandName_);
          }
        },
        error => {
          self.window_c[
            "Please read and agree terms and conditions "
          ] = self.window_c[
            "Please read and agree terms and conditions "
          ].replace("BRANDNAME", "The Food Story");
          self.window_c["terms and conditions "] = self.window_c[
            "terms and conditions "
          ].replace("BRANDNAME", "The Food Story");
          self.window_c["to become member of The Food Story"] = self.window_c[
            "to become member of The Food Story"
          ].replace("BRANDNAME", "The Food Story");
          console.log(error);
        }
      );
    },
    register () {
      var form = this.form;
      var self = this;
      if (!form.phone) {
        this.$toast(self.window_c["Please enter your mobile number"]);
      } else if (!regExpPhone.test(form.phone)) {
        this.$toast(self.window_c["Mobile number format error"]);
      } else if (!form.authCode) {
        this.$toast(self.window_c["Enter the verification code"]);
      } else if (!form.password) {
        this.$toast(self.window_c["Please enter the password"]);
      } else if (form.password && form.password.length < 6) {
        this.$toast(
          self.window_c["Please enter a password of at least 6 digits"]
        );
      } else if (!form.checked) {
        this.$toast(self.window_c["Please check the service agreement"]);
      } else if (form.recommendationCode && !this.recommendationFlag) {
        this.$toast("邀請碼不正確,請重新輸入!");
      } else {
        // 校驗驗證碼
        checkSmsCode({
          phone: form.phone,
          countryId: this.loginData.countryId,
          code: form.authCode
        })
          .then(res => {
            if (res.success) {
              let t = {
                phone: form.phone,
                countryId: this.loginData.countryId,
                code: form.authCode,
                password: form.password
              };
              sessionStorage.setItem(
                "food-story-register-data",
                JSON.stringify(t)
              );
              this.$router.replace({
                name: "information",
                params: {
                  arg: myfn.setQueryParams(myfn.getBrandId(this, 1))
                }
              });
            } else {
              if (res.errCode == "SMS.0005") {
                this.$toast("短信驗證碼錯誤!");
              } else {
                this.$toast(res.errMsg);
              }
            }
          })
          .catch(err => { });
      }
    },

    changeRead () { },
    isRead () {
      this.showDialog = true;
      if (!this.form.checked) {
        this.form.checked = true;
      } else {
        this.form.checked = false;
      }
    },
    viewPassword () {
      this.isshow = !this.isshow;
    },
    phoneReg (e) {
      var val = myfn.numberRegex(e);
      this.form.phone = val;
    },
    yzmReg (e) {
      var val = myfn.numberRegex(e);
      this.form.authCode = val;
    },
    // 修改当前选择区号id
    selectCountry (item) {
      this.loginData.countryId = item.id;
      if (item.id == 3) {
        this.phoneMaxLength = 11
      } else {
        this.phoneMaxLength = 8
      }
    },
    // 推薦碼 失去焦點
    codeBlur () {
      let code = this.form.recommendationCode;
      if (!code) {
        return;
      } else if (code.toString().length != 6) {
        this.$toast("請輸入6位數推薦碼");
      } else {
        checkInvitationCode({
          brandId: myfn.getBrandId(this, 1),
          invitationCode: code
        }).then(res => {
          if (!res.success) {
            this.recommendationFlag = false;
            this.$toast("邀請碼不正確,請重新輸入!");
          } else {
            this.recommendationFlag = true;
            localStorage.setItem("recommendationCode", code);
          }
        });
      }
    }
  },
  components: {
    headNav,
    areaCode
  }
};
</script>
<style scoped lang="less">
.areaCode {
  display: flex;
  margin: 16px 0;
  & /deep/ .van-cell {
    margin: 0 !important;
  }
}
#register .van-hairline--top-bottom:after,
#register .van-hairline-unset--top-bottom:after {
  border-width: 0;
}

#register .van-cell-group__title {
  color: #000;
  padding: 14px 16px 0px;
}

#register .van-cell__value,
#register .van-cell__value--alone {
  border-bottom: 1px solid #e4e4e4;
  padding-bottom: 8px;
}

#register .van-checkbox__icon .van-icon {
  border-color: #3c3c3c;
}

#register {
  background: #fff;
  display: flex;
  flex-direction: column;
}

.cell-content {
  padding-top: 0;
  /* margin-bottom: 200px; */
}

.cell-title {
  font-size: 60px;
  color: #000;
}

.cell-desc {
  font-size: 26px;
  color: #222;
  margin: 20px 0 60px;
}

.cell-code {
  outline: none;
  border: none;
  padding: 10px 20px;
  background-color: rgba(90, 187, 167, 1);
  color: #fff;
  border-radius: 8px;
  font-size: 15px;
  text-align: center;
}

.cell-code[disabled] {
  background-color: rgba(90, 187, 167, 0.5);
}

.cell-icon {
  width: 25px;
  height: 25px;
  margin-top: 10px;
}

.cell-clause {
  color: #333;
  font-size: 14px;
}

.cell-clause:active {
  color: #596d96;
  text-decoration: none;
  text-decoration: underline;
}

.cell-button p {
  width: calc(100% - 20px);
  height: 44px;
  line-height: 44px;
  text-align: center;
  background-color: #5abba7;
  color: #fff;
  border-radius: 8px;
  margin: 0 auto;
  font-size: 17px;
}

div.cell-button-box p {
  /* width: 610px; */
}

.cell-button p:active {
  opacity: 0.8;
}

.cell-Dialog-box {
  position: absolute;
  width: calc(100% - 20px);
  height: calc(100% - 40px);
  background: #d3d3d3;
  padding: 10px;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
}

.cell-container {
  width: 100%;
  height: 860px;
  overflow-y: scroll;
  background-color: #fff;
  padding: 10px;
}

.cell-container-p {
}

.cell-container-title {
}

.cell-agree {
  display: flex;
  align-items: center;
  margin: 20px 0;
}

.conditions {
  text-decoration: underline;
  color: #56ac9a;
}

.self_cell-form {
  padding-bottom: 15px;
}

.self_cell-clause {
  font-size: 13px !important;
}

.self_b {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/view/register.vue